import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Alert"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "alert"
    }}>{`Alert`}</h1>
    <p>{`Component for displaying messages, notifications, or other application state.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Alert } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Alert>
  Beep boop, this is an alert!
  <Close ml="auto" mr={-2} />
</Alert>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Alert variant='secondary' mb={2}>Secondary</Alert>
<Alert variant='accent' mb={2}>Accent</Alert>
<Alert variant='highlight' mb={2}>Highlight</Alert>
`}</code></pre>
    <p>{`If screen readers should immediately start reading the alert aloud,
`}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Alert_Role"
      }}>{`add `}<inlineCode parentName="a">{`role="alert"`}</inlineCode></a>{`.`}</p>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Alert variants can be defined in `}<inlineCode parentName="p">{`theme.alerts`}</inlineCode>{`.
The Alert component uses `}<inlineCode parentName="p">{`theme.alerts.primary`}</inlineCode>{` as its default variant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme variants
{
  alerts: {
    primary: {
      color: 'background',
      bg: 'primary',
    },
    muted: {
      color: 'text',
      bg: 'muted',
    },
  },
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      